import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import * as hippoConstFactory from 'common/hippoConst';

const module = angular.module('claims-contact-me-card', []);

interface ClaimsContactMeCardController extends angular.IStrictController {
    icon: string;
    description: string;
    triggerEmail: () => void;
    reason: ContactReason;
    policyInfo: CustomerPolicyInfo;
}

module.component('claimsContactMeCard', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(this: ClaimsContactMeCardController) {
        this.$onInit = () => {
            const HIPPO_CONSTS = hippoConstFactory();
            this.icon = 'phone-with-message';
            this.description = `
                Need to file a claim? <br/> Call us at <strong>${HIPPO_CONSTS.HIPPO_CLAIMS_PHONE_NUMBER}</strong><br/>
                or let us contact you`;
            this.reason = 'file-claim';
        };
    }
});

export { module };
